import { TimeZones } from "../../enums/TimeZones";

export class ManualAddressDto {
    public id: number;
    public skin: string;
    public key: string;
    public addressLine1: string;
    public addressLine2: string;
    public address: string;
    public city: string;
    public province: string;
    public state: string;
    public postalCode: string;
    public country: string;
    public formattedAddress: string;
    public timeZone: TimeZones;
    public latitude: number;
    public longitude: number;

    public static buildFromPhase(phase: { addressId?: number; addressSkin?: string; addressKey?: string; addressLine1?: string; addressLine2?: string; city?: string; province?: string; state?: string; postalCode?: string; country?: string; formattedAddress?: string; longitude?: number; latitude?: number; }): ManualAddressDto {
        const dto = new ManualAddressDto();
        dto.id = phase.addressId;
        dto.skin = phase.addressSkin;
        dto.key = phase.addressKey;
        dto.addressLine1 = phase.addressLine1;
        dto.addressLine2 = phase.addressLine2;
        dto.city = phase.city;
        dto.province = phase.province;
        dto.state = phase.state;
        dto.postalCode = phase.postalCode;
        dto.country = phase.country;
        dto.formattedAddress = phase.formattedAddress;
        dto.longitude = phase.longitude;
        dto.latitude = phase.latitude;
        return dto;
    }
}
